import React from "react";
import "../stylesheets/DevLog.css";

import DevLog1 from "./Dev Logs/DevLog1";
import DevLog2 from "./Dev Logs/DevLog2";
import DevLog3 from "./Dev Logs/DevLog3";
import DevLog4 from "./Dev Logs/DevLog4";
import DevLog5 from "./Dev Logs/DevLog5";
import DevLog6 from "./Dev Logs/DevLog6";

// console.log(DevLog1.render());
// export const logs = [0, DevLog1.render()];
export const logs = [
  0,
  DevLog1.render(),
  DevLog2.render(),
  DevLog3.render(),
  DevLog4.render(),
  DevLog5.render(),
  DevLog6.render(),
];

class DevLog extends React.Component {
  render() {
    const content = logs[this.props.match.params.id].props.children;
    const id = this.props.match.params.id;

    return (
      <div className="devlog-container">
        <h1 className="devlog-heading">
          Discovery Log #{id}: {content[0].props.children}
        </h1>
        <h4 className="devlog-date">{content[1].props.children}</h4>
        <div className="devlog-content">{content[2].props.children}</div>
      </div>
    );
  }
}

export default DevLog;
